export enum SpendType {
    AUTO = 'AUTO',
    MANUAL = 'MANUAL',
}

export interface Spend {
    id?: string;
    type: SpendType;
    membershipId: string;
    amount: number; // dollars
    period: Date;
    confirmed: boolean;
}

// Read DTO
export interface MembershipSpend extends Spend {
    id: string; // id required on reads.
    createdAt: string;
    updatedAt: string;
}

export interface MembershipSpendUpsertDto extends Spend {}
